import { render, staticRenderFns } from "./cardClinic.vue?vue&type=template&id=be6f80f4&scoped=true"
import script from "./cardClinic.vue?vue&type=script&lang=js"
export * from "./cardClinic.vue?vue&type=script&lang=js"
import style0 from "./cardClinic.vue?vue&type=style&index=0&id=be6f80f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6f80f4",
  null
  
)

export default component.exports